import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import { useState } from '@/hooks'
import { constant } from './constant'

Swiper.use([Navigation])

type State = {
	swiper?: Swiper
}

export const SwiperComponent = (() => {
	const { state, setState } = useState<State>({
		swiper: undefined,
	})

	const initSwiper = () => {
		if (state.swiper) {
			state.swiper.destroy(true)
		}

		// eslint-disable-next-line no-new
		const swiper = new Swiper(constant.container, {
			direction: 'horizontal',
			followFinger: true,
			observer: true,
			observeParents: true,
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			pagination: {
				el: constant.paginator,
				clickable: true,
			},
			slidesPerView: 1,
			autoHeight: true,
			navigation: {
				nextEl: constant.buttonNext,
				prevEl: constant.buttonPrevious,
			},
		})

		setState({ swiper })
	}

	const init = () => {
		initSwiper()
	}

	return {
		init,
	}
})()
